import initReactApp from 'dpl/util/initReactApp';
import ReviewsPageLink from 'dpl/homepage/components/ReviewsPageLink';
import BreedersByBreedSection from 'dpl/homepage/components/BreedersByBreedSection';
import SheltersSection from 'dpl/homepage/components/SheltersSection';
import FutureBreederVideosSection from 'dpl/homepage/components/FutureBreederVideosSection';
import GoodDogHomeSection from 'dpl/homepage/components/GoodDogHomeSection';
import MobileAppQRSection from 'dpl/homepage/components/MobileAppQRSection';
import GoodDogNewsSection from 'dpl/homepage/components/GoodDogNewsSection';
import BreedOverviewPagesFooterSection from 'dpl/homepage/components/BreedOverviewPagesFooterSection';
import PopularBreedsFooterSection from 'dpl/homepage/components/PopularBreedsFooterSection';
import PopularBreedCardSection from 'dpl/homepage/components/PopularBreedCardSection';
import OwnerStoriesSection from 'dpl/homepage/components/OwnerStoriesSection';
import HomepageSearchBar from 'dpl/homepage/components/HomepageSearchBar';
import MobileHomepageSearchBar from 'dpl/homepage/components/MobileHomepageSearchBar';
import LearningCenterArticleCardSection from 'dpl/homepage/components/LearningCenterArticleCardSection';
import GoodDogStandardSectionButton from 'dpl/homepage/components/GoodDogStandardSectionButton';
import { setAnalyticsOrigin } from 'dpl/shared/utils/setAnalyticsOrigin';
import { ANALYTICS_VIEWS } from 'dpl/constants/analytics';

setAnalyticsOrigin({
  originView: ANALYTICS_VIEWS.HOME
});

initReactApp({
  HomepageSearchBar,
  MobileHomepageSearchBar,
  ReviewsPageLink,
  BreedersByBreedSection,
  SheltersSection,
  FutureBreederVideosSection,
  OwnerStoriesSection,
  GoodDogHomeSection,
  MobileAppQRSection,
  GoodDogNewsSection,
  PopularBreedsFooterSection,
  PopularBreedCardSection,
  BreedOverviewPagesFooterSection,
  LearningCenterArticleCardSection,
  GoodDogStandardSectionButton
});
